import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Redirect } from "react-router";
import TourMenu from "./TourMenu/TourMenu";
import TourMobileMenu from "./TourMenu/TourMobileMenu";
import TourHeader from "./TourHeader";
import TourStore from "~/stores/TourStore";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import ContentLoader from "~/components/element/ContentLoader";
import TourAcl from "./TourAcl";
import NotAuthorizedPage from "~/components/element/NotAuthorizedPage";
import AuthenticatedUserHelper from "~/utils/AuthenticatedUserHelper";
import RouteWrapper from "~/components/wrapper/RouteWrapper";
import TourNav from "../constants/TourNav";
import ToastMessageStore from "~/stores/ToastMessageStore";
import ToastMessageContainer from "~/components/ToastMessageContainer";
import "../styles/TourLayout.less";

function TourLayoutWrapper(WrappedComponent, active = "") {
  @observer
  class TourLayout extends Component {
    ref = null;

    constructor(props) {
      super(props);

      this.state = {
        isLoading: true,
        notAuthorized: false,
      };

      this.ref = createRef();
    }

    componentDidMount() {
      const { tourStore, match, showError, query } = this.props;
      const tourId = parseInt(match.params.tourId, 10);

      if (query && query.token) {
        tourStore.token = query.token;
      }

      tourStore
        .load(tourId)
        .catch(error => {
          if (error.message.startsWith("Access denied")) {
            this.setState({ notAuthorized: true });
          } else {
            showError(error.message);
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    }

    render() {
      const { ...rest } = this.props;
      const { isLoading, notAuthorized } = this.state;
      const { match, tourStore, user, query, toastMessageStore } = rest;
      const { tour } = tourStore;
      const tourId = parseInt(match.params.tourId, 10);

      if (isLoading || tourStore.isLoading || !tour) {
        return <ContentLoader />;
      }

      if (notAuthorized) {
        return <NotAuthorizedPage />;
      }

      // Redirect to RansomReview page if the user is navigating in any other tour page that is not the RansomReview page.
      if (active !== TourNav.RANSOM_REVIEW && tour.acl.ransomReview) {
        return <Redirect to={`/tours/${tour.tourId}/review`} />;
      }

      let token = null;

      if (query && query.token) {
        token = query.token;
      }

      return (
        <div id="tourLayoutWrapper" className="primary-container">
          <TourAcl active={active} tour={tour}>
            {AuthenticatedUserHelper.isAuthenticatedCustomer(user) && tourId ? (
              <TourHeader
                {...this.props}
                active={active}
                tourId={tourId}
                customerHasUrbanimmersiveGroupSpecialPricing={
                  typeof user.customer !== "undefined" &&
                  typeof user.customer.hasUrbanimmersiveGroupSpecialPricing !== "undefined"
                    ? user.customer.hasUrbanimmersiveGroupSpecialPricing
                    : false
                }
              />
            ) : null}
            <div className="tour-layout-edit-container">
              <div className="tour-layout-mobile-menu">
                <TourMobileMenu tourId={tourId} active={active} tourAcl={tour.acl} user={user} token={token} />
              </div>
              <div className="tour-layout-sidebar-container">
                <TourMenu tourId={tourId} active={active} tourAcl={tour.acl} user={user} token={token} />
              </div>
              <div className="tour-layout-content-container" ref={this.ref}>
                <WrappedComponent tourId={tourId} tour={tour} tourLayoutContentContainerRef={this.ref} {...rest} />
              </div>
            </div>
          </TourAcl>
          <ToastMessageContainer toastMessageStore={toastMessageStore} />
        </div>
      );
    }
  }

  TourLayout.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        tourId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }),
    tourStore: PropTypes.instanceOf(TourStore),
    toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
  };

  return ErrorWrapper(RouteWrapper(TourLayout));
}

export default TourLayoutWrapper;
